import React, { useState, useEffect } from 'react';

/**
 * Aydınlatma hattı bölme menüsü.
 * Sağ tıklama ile açılır; kullanıcı toplam armatür sayısını seçer.
 * Mevcut sayıdan fazla olan seçenekler aktif, diğerleri pasif.
 */
export default function WireSplitMenu({ x: initX, y: initY, existingCount, onSplit, onPreview, onClose }) {
  const [pos, setPos] = useState({ x: initX, y: initY });
  const [hoveredN, setHoveredN] = useState(null);
  const stop = e => e.stopPropagation();

  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const onHeaderMouseDown = e => {
    e.stopPropagation();
    const sx = e.clientX - pos.x, sy = e.clientY - pos.y;
    const onMove = ev => setPos({ x: ev.clientX - sx, y: ev.clientY - sy });
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp, { capture: true });
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp, { capture: true });
  };

  // Minimum secim: mevcut sayidan bir fazlasi (en az 1 yeni araatür eklenmeli)
  const minCount = existingCount + 1;

  return (
    <div
      onMouseDown={stop} onMouseUp={stop} onClick={stop}
      style={{
        position: 'fixed', left: pos.x, top: pos.y, zIndex: 100000,
        background: 'rgba(20,30,40,0.95)', color: '#aff',
        border: '1px solid #0aa', borderRadius: 4, padding: 6,
        font: '12px/1.3 "Segoe UI", sans-serif',
        boxShadow: '0 2px 8px rgba(0,0,0,0.5)', userSelect: 'none',
        minWidth: 170,
      }}
    >
      {/* Başlık (sürüklenebilir) */}
      <div
        onMouseDown={onHeaderMouseDown}
        style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          marginBottom: 6, cursor: 'grab', paddingBottom: 4,
          borderBottom: '1px solid rgba(0,170,170,0.3)',
        }}
      >
        <span style={{ fontWeight: 'bold' }}>Aydınlatma Hattı — Böl</span>
        <button
          onMouseDown={e => e.stopPropagation()}
          onClick={onClose}
          style={{ background: 'none', border: 'none', color: '#aff', cursor: 'pointer', fontSize: 14, lineHeight: 1 }}
          title="Kapat (Esc)"
        >×</button>
      </div>

      <div style={{ fontSize: 10, color: '#888', padding: '0 4px 6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        Toplam armatür sayısını seçin
      </div>

      {/* 1-9 ızgara */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 3, marginBottom: 4 }}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(n => {
          const enabled = n >= minCount;
          return (
            <div
              key={n}
              onClick={() => enabled && onSplit(n)}
              onMouseEnter={() => { if (enabled) { setHoveredN(n); onPreview?.(n); } }}
              onMouseLeave={() => { setHoveredN(null); onPreview?.(null); }}
              style={{
                padding: '7px 4px', textAlign: 'center', borderRadius: 3,
                fontWeight: 700, fontSize: 15,
                cursor: enabled ? 'pointer' : 'not-allowed',
                opacity: enabled ? 1 : 0.25,
                background: hoveredN === n ? 'rgba(0,200,170,0.3)' : 'rgba(255,255,255,0.05)',
                border: `1px solid ${hoveredN === n ? 'rgba(0,200,170,0.6)' : 'rgba(0,170,170,0.2)'}`,
                color: hoveredN === n ? '#fff' : '#aff',
                transition: 'background 0.1s, border-color 0.1s',
              }}
              title={enabled ? `Toplam ${n} armatür — ${n - existingCount} yeni eklenecek` : 'Mevcut sayıdan az'}
            >
              {n}
            </div>
          );
        })}
      </div>

      {/* Hover bilgisi */}
      <div style={{
        fontSize: 11, color: '#fc8', padding: '3px 4px',
        borderTop: '1px solid rgba(0,170,170,0.2)', marginTop: 2,
        minHeight: 18,
      }}>
        {hoveredN !== null && hoveredN >= minCount
          ? `${hoveredN - existingCount} yeni armatür eklenecek (toplam ${hoveredN})`
          : <span style={{ color: '#666' }}>Mevcut: {existingCount} armatür</span>
        }
      </div>
    </div>
  );
}
